import React from 'react'
import { useLocation } from 'react-router-dom'
import {
  odxDataTranslator,
  alerts,
  checFeatures,
  requirements,
  releaseNotes,
  temEnablement,
} from 'constants/routes'
import strings from 'utils/strings'
import {
  FloatingContainer,
  Blurb,
  Transition,
  QuestionMark,
} from './Help.style'

const EXCLUDED_ROUTES = [
  odxDataTranslator,
  alerts,
  checFeatures,
  requirements,
  releaseNotes,
  temEnablement,
]

const Help = () => {
  const { pathname } = useLocation()

  const excludedRoute = EXCLUDED_ROUTES.includes(pathname)

  if (excludedRoute) return null

  const hasZoomControlFooter =
    pathname.includes('switchandgauge') ||
    (pathname.includes('pto') && !pathname.includes('templates'))

  return (
    <FloatingContainer hasZoomControlFooter={hasZoomControlFooter}>
      <a
        target="_blank"
        href="https://dtnacontent-dtna.prd.freightliner.com/content/dtna-portal/en/ServiceLP/CHEC_Documentation.html"
        rel="noopener noreferrer"
      >
        <Transition>
          <Blurb>
            <span>{strings.cant_find_what_looking_for}</span>
          </Blurb>
          <QuestionMark>
            <span>
              <svg
                width={9}
                height={13}
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M2.731 8.78h2.32v-.463c0-.286.044-.535.131-.745.088-.21.24-.408.456-.595a5.5 5.5 0 0 1 .901-.621c.619-.362 1.086-.78 1.401-1.252.315-.479.473-1.048.473-1.707v-.018c0-.665-.175-1.252-.525-1.76-.345-.507-.83-.904-1.454-1.19C5.816.143 5.09 0 4.254 0 3.363 0 2.6.155 1.97.464 1.345.774.864 1.205.525 1.76.193 2.308.018 2.938 0 3.65v.018l2.364-.009.017-.008c.018-.327.1-.61.245-.85.146-.245.345-.434.596-.569.25-.134.542-.201.875-.201.333 0 .624.064.875.193.251.122.444.291.578.507.14.21.21.453.21.727v.017c0 .275-.043.514-.131.718-.088.205-.24.4-.455.587-.21.187-.505.394-.884.621a4.34 4.34 0 0 0-.972.753 2.285 2.285 0 0 0-.517.92c-.093.338-.122.738-.087 1.199l.017.507zM3.983 13c.49 0 .876-.131 1.156-.394.286-.263.429-.619.429-1.068 0-.461-.143-.82-.43-1.077-.28-.262-.665-.394-1.155-.394s-.878.132-1.164.394c-.286.257-.43.616-.43 1.077 0 .45.144.805.43 1.068.286.263.674.394 1.164.394z"
                  fill="#6C18BA"
                />
              </svg>
            </span>
          </QuestionMark>
        </Transition>
      </a>
    </FloatingContainer>
  )
}

export default Help
